module.exports = __webpack_public_path__ + "img/playIcon.3424496a.png";